import React from "react";

const AuthenticationContext = React.createContext({
    isAuthenticated: false,
    setIsAuthenticated: value => {},
});
export default AuthenticationContext;